/** @module csi/gallery/ToolbarBatchFilter */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"lodash",
	"csi/def/Action",
	"csi/html",
	"csi/toolbar/BatchFilter",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
], function(declare, lang, _, Action, html, BatchFilter, PluginFactory, ToolbarPlugin) {

	// This module is toolbar plugin which implements table Batch Filter toggle button which toggle Batch Filter container visibility on/off
	// see csi/toolbar/BatchFilter for Batch Filter code

	return PluginFactory.declare("filter", [BatchFilter, ToolbarPlugin], {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {m_id: "ViewQuery"});
		},

		canShowPlugin: function() {
			var view = this.getView();
			// hide batch filter and batch filter container if table is empty prior to filtering
			const isEmptyGallery = !view.queryDisplayCount && !view._groupColValues && !view._groupRowValues && _.isEmpty(view.query) && !view.isSuspended();
			const canShow = !view.disableAdHoc && !isEmptyGallery
			html.setVisible(this.filterContainer.domNode, canShow);
			return canShow;
		},

		/**
		 * Associate BatchFilter with view toolbar
		 */
		postCreate: function() {
			this.set("queryMixin", this.getView());
			this.createFilterContainer(this.actionToolbar.domNode);
			this.inherited(arguments);
			this.domNode.classList.add("csi-batch-filter");

			var view = this.getView();
			view.watch("disableAdHoc", lang.hitch(this, this._onWatchDisableAdHoc));
			this._onWatchDisableAdHoc(null, null, view.get("disableAdHoc"));
		},

		/**
		 * change visibility of batch filter
		 * @param {string} name 
		 * @param {any} oldValue 
		 * @param {any} newValue 
		 */
		_onWatchDisableAdHoc: function(name, oldValue, newValue) {
			const bVisible = !newValue;
			if (oldValue == false) {
				this.filterContainer.onClearFilters();
			}
			html.setVisible(this.filterContainer, bVisible);
		},

		/**
		 * Do not instantiate plugin when printing or on views that have no data (such as template views)
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint && !!ctx.getContextNode();
		},

		/**
		 * Invoke filter action - if only one result, then automatically select it
		 * @param {Object} value
		 * @param {Action} action
		 */
		onChange: function(value, action) {
			var view = this.getView();
			var fd = view.defView.m_formData;
			if (fd && fd.m_bSelectOne && (value != null)) {
				view.bSelectIfOne = true;
			}

			this.inherited(arguments);
		},

		/**
		 * extension point. Not used for gallery yet.
		 */
		_onChangeFilter: function() {

		},

		/**
		 * @override
		 * resize view
		 */
		_onClickAction: function(evt) {
			this.inherited(arguments);
			this.queryMixin.resize();
		},

	});
});